var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookDesktopAdLike = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M11.95 4.96h-5c.021-.008.427-.862.427-1.475 0-.612.003-1.624 0-1.645C7.256 1.041 7.269.248 6.5.035 5.298-.298 5.833 1.84 5.484 2.422c-.349.581-.751.709-1.14 1.186-.47.576-1.322 1.453-1.394 1.453v6.899h7.5v-1.5l.5-1-.453-1h.753v-2zM0 11.88h1.946V4.99H0z"
})));
export default SvgFacebookDesktopAdLike;